import { MainProvider } from "./providers";
import { MainRoutes } from "./routes";
import { useEffect } from "react";

const usePreventRefresh = () => {
  useEffect(() => {
    const handleBeforeUnload = (event: BeforeUnloadEvent) => {
      event.preventDefault();
      event.returnValue = ""; // 크롬에서 필요한 설정
    };

    window.addEventListener("beforeunload", handleBeforeUnload);

    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, []);
};

export default function App() {
  usePreventRefresh()
  
  return (
    <MainProvider>
      <MainRoutes />
    </MainProvider>
  );
}
